import MainLayout from '@/common/components/layouts/MainLayout';
import ShowIncidentParticipantsDataCard from '@/common/components/showIncidentParticipantsDataCard/ShowIncidentParticipantsDataCard';
import { showIncidentParticipantsData } from '@/common/components/showIncidentParticipantsDataCard/ShowIncidentParticipantsDataCard.type';
import LoadingPage from '@/common/pages/LoadingPage';
import CarTab from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/carTab.svg?react';
import UserTab from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/userTab.svg?react';
import SwitchTab from '@/modules/adjusterReportModules/IncidentParticipants/components/common/SwitchTab';
import { getCulpritDriverInfoQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/culprit/getculpritDriverInfo/getCulpritDriverInfoQueryOptions';
import { getCulpritUserInformationQueryOption } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getCulpritUserInformation/getCulpritUserInformationQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Flex } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout title="مقصر / راننده - مالک" header="titleHeader">
      <ShowCulpritInformation />
    </MainLayout>
  );
};

const tabs = [
  {
    title: 'مشخصات راننده',
    activeTabIndex: 1,
    icon: <CarTab stroke="currentColor" />,
  },
  {
    title: 'مشخصات مالک',
    activeTabIndex: 2,
    icon: <UserTab stroke="currentColor" />,
  },
];

const ShowCulpritInformation = () => {
  const [activeTab, setActiveTab] = useState(1);
  const { id } = useParams();
  const {
    data: ownerInformation,
    refetch: refetchOwnerInformation,
    isPending: isPendingOwner,
  } = useQuery(getCulpritUserInformationQueryOption(+id!));

  const {
    data: driverInformation,
    refetch: refetchDriverInformation,
    isPending: isPendingDriver,
  } = useQuery(getCulpritDriverInfoQueryOptions({ id: +id! }));

  useEffect(() => {
    if (activeTab === 2) {
      refetchOwnerInformation();
    } else {
      refetchDriverInformation();
    }
  }, [activeTab]);

  if (isPendingDriver && isPendingOwner) {
    return <LoadingPage />;
  }

  return (
    <Box pt={24}>
      <SwitchTab
        activeTab={activeTab}
        tabs={tabs}
        getActiveTab={(activeTab: number) => setActiveTab(activeTab)}
      />
      <Box mt={26}>
        {activeTab === 1 && (
          <Flex direction="column" gap={16}>
            <ShowIncidentParticipantsDataCard
              title="اطلاعات پایه"
              data={
                (driverInformation?.mappedData
                  .personal_information as showIncidentParticipantsData[]) ?? []
              }
            />
            <ShowIncidentParticipantsDataCard
              title="اطلاعات گواهینامه"
              data={
                (driverInformation?.mappedData
                  .certificate as showIncidentParticipantsData[]) ?? []
              }
            />
            <ShowIncidentParticipantsDataCard
              title="اطلاعات تماس"
              data={
                (driverInformation?.mappedData
                  .contact as showIncidentParticipantsData[]) ?? []
              }
            />
          </Flex>
        )}
        {activeTab === 2 && (
          <Flex direction="column" gap={16}>
            <ShowIncidentParticipantsDataCard
              title="اطلاعات پایه"
              data={
                (ownerInformation?.mappedData
                  .personal_information as showIncidentParticipantsData[]) ?? []
              }
            />
            <ShowIncidentParticipantsDataCard
              title="اطلاعات تماس"
              data={
                (driverInformation?.mappedData
                  .personal_information as showIncidentParticipantsData[]) ?? []
              }
            />
          </Flex>
        )}
      </Box>
    </Box>
  );
};
